exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".graphicItem [darkModeSlide]{display:none}@media(prefers-color-scheme:dark){.graphicItem [darkModeSlide]{display:initial}}.graphicItem svg{transform:translate(-50%,-7.5%)}.graphicItem img,.graphicItem svg{width:100%;max-height:100vh;position:fixed}.graphicItem img{transform:translate(-50%,50%)}@media screen and (min-width:830px){.graphicItem img{transform:translate(-50%)}}#slides{padding:0;margin:0;list-style-type:none}.slide{position:absolute;left:0;top:0;width:100%;height:100%;opacity:0;z-index:1;transition:opacity 1s}.showing{opacity:1;z-index:20}", ""]);

// exports
